import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2, Clock, Video } from "lucide-react";
import DailyVideoFrame from "@/components/DailyVideoFrame";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/** Provider joins a consult via their secret link - no account needed. */
export default function ProviderJoinPage() {
  const { joinCode } = useParams();
  const [joinInfo, setJoinInfo] = useState(null);
  const [error, setError] = useState(null);
  const [left, setLeft] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/consults/provider-join/${joinCode}`)
      .then((res) => setJoinInfo(res.data))
      .catch((err) => {
        const detail = err.response?.data?.detail;
        setError(typeof detail === "string" ? detail : "Unable to join this consult.");
      });
  }, [joinCode]);

  return (
    <div className="min-h-screen bg-[#0B1726]">
      <header className="px-4 sm:px-6 py-4 max-w-7xl mx-auto flex items-center gap-2 text-white font-body">
        <Video className="w-5 h-5 text-secondary" />
        {joinInfo ? (
          <span>
            <strong>{joinInfo.consult.provider_name}</strong> — consult with {joinInfo.consult.family_name}
          </span>
        ) : (
          <span>Asher Care Navigation — Virtual Consult</span>
        )}
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 pb-8">
        {error ? (
          <div className="flex flex-col items-center justify-center h-[60vh] gap-4 text-center">
            <Clock className="w-12 h-12 text-secondary" />
            <p data-testid="provider-join-error" className="text-white font-body text-lg max-w-md">{error}</p>
          </div>
        ) : left ? (
          <div className="flex flex-col items-center justify-center h-[60vh] gap-4 text-center">
            <p className="text-white font-body text-lg">You left the consult. You can close this window.</p>
          </div>
        ) : !joinInfo ? (
          <div className="flex items-center justify-center h-[60vh]">
            <Loader2 className="w-10 h-10 animate-spin text-secondary" />
          </div>
        ) : (
          <div className="space-y-3">
            <DailyVideoFrame roomUrl={joinInfo.room_url} token={joinInfo.token} onLeave={() => setLeft(true)} />
            <p className="text-white/60 font-body text-xs text-center">
              🔒 Private, encrypted video room provided by Asher Care Navigation.
            </p>
          </div>
        )}
      </main>
    </div>
  );
}
